export default {
    resetROIOrder(state) {
        const order = {
            type: 'ROI',
            relation: {
                id: null,
                createTimestamp: null,
                modifiedTimestamp: null,
                deletedTimestamp: null,
                isAnonymized: null,
                organizationID: null,
                externalReference: null,
                type: 'CONSUMER',
                isParent: null,
                parentID: null,
                firstName: null,
                middleName: null,
                lastName: null,
                gender: 'MALE',
                birthDate: null,
                phoneNumber: null,
                mobileNumber: null,
                email: null,
                street: null,
                houseNumber: null,
                houseNumberAddition: null,
                postalCode: null,
                city: null,
                country: null,
                companyName: null,
                companyCocNumber: null,
                bankAccountType: null,
                bankAccountNumber: null,
                debtorName: null,
                saveToRevision: false,
            },
            relationID: null,
            signatureType: 'ESIGNATURE',
            signatureData: null,
            productID: null,
            key: Math.random(),
            extraData: {
                model: '',
                consumption_peak: 0,
                consumption_offpeak: 0,
                feedin_peak: 0,
                feedin_offpeak: 0,
                physical_capacity: '',
                contract_end_date: '',
                contract_type: '',
                customer_wishes: '',
                notes: '',
                number_of_solar_panels: 0,
                taxable_income: 0,
            },
        };
        state.order = order;
    },

    preFillRelationOnROIOrderBegin(state) {
        state.errorPreFillRelationOnOrder = false;
        state.loadingPreFillRelationOnOrder = true;
    },

    preFillRelationOnROIOrderSuccess(state) {
        state.loadingPreFillRelationOnOrder = false;
    },

    preFillRelationOnROIOrderErr(state, err) {
        state.loadingPreFillRelationOnOrder = false;
        state.errorPreFillRelationOnOrder = err;
    },

    addRelationToROIOrder(state, data) {
        const order = JSON.parse(JSON.stringify(state.order));

        if (data.type === 'CONSUMER') {
            data.companyName = null;
            data.companyCocNumber = null;
        }

        order.relation = data;
        if (data.id !== undefined) {
            order.relationID = data.id;
        }
        order.key = Math.random();
        state.order = order;
    },

    calculatePriceBegin(state) {
        state.errorCalculatePrice = false;
        state.loadingCalculatePrice = true;
    },

    calculatePriceSuccess(state) {
        state.errorCalculatePrice = false;
        state.loadingCalculatePrice = false;
    },

    calculatePriceErr(state, err) {
        state.loadingCalculatePrice = false;
        state.errorCalculatePrice = err;
    },

    addQuestionsROIOrder(state, data) {
        const order = JSON.parse(JSON.stringify(state.order));
        order.extraData.model = data.model;
        order.extraData.consumption_peak = data.consumption_peak;
        order.extraData.consumption_offpeak = data.consumption_offpeak;
        order.extraData.feedin_peak = data.feedin_peak;
        order.extraData.feedin_offpeak = data.feedin_offpeak;
        order.extraData.physical_capacity = data.physical_capacity;
        order.extraData.contract_end_date = data.contract_end_date;
        order.extraData.contract_type = data.contract_type;
        order.extraData.customer_wishes = data.customer_wishes;
        order.extraData.notes = data.notes;
        order.extraData.number_of_solar_panels = data.number_of_solar_panels;
        order.extraData.taxable_income = data.taxable_income;
        order.key = Math.random();
        state.order = order;
    },

    createROIOrderBegin(state) {
        state.errorCreateOrder = false;
        state.loadingCreateOrder = true;
    },

    createROIOrderSuccess(state) {
        state.loadingCreateOrder = false;
        // Optionally store the created order response if needed in the future
    },

    createROIOrderErr(state, err) {
        state.loadingCreateOrder = false;
        state.errorCreateOrder = err;
    },

    setSignatureROIData(state, data) {
        const order = JSON.parse(JSON.stringify(state.order));
        order.signatureData = data;
        order.key = Math.random();
        state.order = order;
    },

    setProductId(state, data) {
        const order = JSON.parse(JSON.stringify(state.order));
        order.productID = data;
        order.key = Math.random();
        state.order = order;
    }
};
